import StandardQnaFilter from './StandardQnaFilter';

const StandardQnA = {
  Filter: StandardQnaFilter
};

export default StandardQnA;
